<template>
  <loader v-if="loading" />
  <div v-else class="order-info-block">
    <h5>{{ blockTitle }}</h5>
    <dl>
      <dt>{{ i18n.t('/OrderInfoBlock/Status') }}</dt>
      <dd>{{ statusLabel }}</dd>
      <template v-if="!quoteIsNew">
        <dt>
          {{ i18n.t('/OrderInfoBlock/QuoteNumber') }}
        </dt>
        <dd data-qa="order-info-quote-number">
          {{ quote.QuoteId }}
        </dd>
      </template>
      <template v-if="hasKomNumber">
        <dt>
          {{ i18n.t('/Dashboard/Table/Kom Number') }}
        </dt>
        <dd data-qa="quote-kom-number">
          {{ quoteKomNumber }}
        </dd>
      </template>
    </dl>

    <set-stock-order />
    <stock-order-info-block />

    <div v-if="isSalesOrder">
      <horizontal-line />
      <edit-sales-order
        ref="editSalesOrderRef"
        :show-edit-button="!hasChildQuotes"
        :show-additional-button="true"
        :show-info-button="true"
        :quote-id="quote.QuoteId"
      />
    </div>

    <app-dropdown-button v-else :button-text="i18n.t('/OrderInfoBlock/MoreQuoteActions')">
      <li>
        <a class="dropdown-item" @click="duplicateQuote">{{
          i18n.t('/DuplicateQuote/ButtonText')
        }}</a>
      </li>
      <li>
        <a class="dropdown-item" @click="transferEmployee">{{
          i18n.t('/TransferQuote/TransferEmployeeButton')
        }}</a>
      </li>
      <li>
        <a class="dropdown-item" @click="transferEstablishment">{{
          i18n.t('/TransferQuote/TransferQuoteEstablishment')
        }}</a>
      </li>
      <li>
        <a v-if="isSalesOrder" class="dropdown-item" @click="editSalesOrder">
          {{ i18n.t('/editsalesorder/editorder') }}
        </a>
      </li>
    </app-dropdown-button>

    <!-- Use this functionality (for the dropdown), but don't show the button itself. -->
    <duplicate-quote ref="duplicateQuoteRef" :show-button="false" />
    <transfer-quote-employee ref="transferEmployeeRef" :show-button="false" />
    <transfer-quote-establishment ref="transferEstablishmentRef" :show-button="false" />

    <span v-if="!minimized">
      <horizontal-line />

      <employee-info />

      <horizontal-line />

      <dealer-info />

      <horizontal-line />
    </span>
  </div>
</template>

<script>
import AppDropdownButton from '@/components/generic/presentational/atoms/appButton/AppDropdownButton.vue'
import SetStockOrder from '@/components/generic/presentational/molecules/setStockOrder/setStockOrder.vue'
import DuplicateQuote from '@/components/generic/presentational/molecules/duplicateQuote/DuplicateQuote.vue'
import EditSalesOrder from '@/components/generic/presentational/molecules/editSalesOrder/EditSalesOrder.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import HorizontalLine from '@/components/generic/presentational/atoms/horizontalLine/HorizontalLine.vue'
import EmployeeInfo from '@/components/generic/presentational/organisms/orderInfoBlock/EmployeeInfo.vue'
import DealerInfo from '@/components/generic/presentational/organisms/orderInfoBlock/DealerInfo.vue'
import StockOrderInfoBlock from '@/components/generic/presentational/organisms/stockOrderInfoBlock/StockOrderInfoBlock.vue'
import TransferQuoteEmployee from '@/components/generic/presentational/organisms/transferQuote/TransferQuoteEmployee.vue'
import TransferQuoteEstablishment from '@/components/generic/presentational/organisms/transferQuote/TransferQuoteEstablishment.vue'
import { getStatus } from '@/helpers/statusHelper'
import { mapGetters } from 'vuex'
import { ref } from 'vue'

export default {
  components: {
    SetStockOrder,
    AppDropdownButton,
    Loader,
    DuplicateQuote,
    EditSalesOrder,
    HorizontalLine,
    EmployeeInfo,
    DealerInfo,
    StockOrderInfoBlock,
    TransferQuoteEmployee,
    TransferQuoteEstablishment,
  },
  props: {
    minimized: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const duplicateQuoteRef = ref(null)
    const transferEmployeeRef = ref(null)
    const transferEstablishmentRef = ref(null)
    const editSalesOrderRef = ref(null)

    return {
      duplicateQuoteRef,
      transferEmployeeRef,
      transferEstablishmentRef,
      editSalesOrderRef,
    }
  },
  data() {
    return {
      carType: '',
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      loading: true,
    }
  },
  computed: {
    ...mapGetters({
      quote: 'quote/get',
      quoteIsNew: 'quote/isNew',
      isSalesOrder: 'quote/quoteStatusIsSalesOrder',
      hasChildQuotes: 'quote/hasChildQuotes',
      quoteKomNumber: 'quote/komNumber',
      hasKomNumber: 'quote/hasKomNumber',
    }),
    blockTitle() {
      return this.isSalesOrder
        ? this.i18n.t('/OrderInfoBlock/SalesOrderTitle')
        : this.i18n.t('/OrderInfoBlock/Title')
    },
    statusLabel() {
      return getStatus(this.quote.Status)
    },
  },
  mounted() {
    this.loading = false
  },
  methods: {
    duplicateQuote() {
      this.duplicateQuoteRef.toggleDuplicateModal(true)
    },
    transferEmployee() {
      this.transferEmployeeRef.transferQuote()
    },
    transferEstablishment() {
      this.transferEstablishmentRef.toggleModal(true)
    },
    editSalesOrder() {
      this.editSalesOrderRef.toggleEditSalesOrderModal(true)
    },
  },
}
</script>

<style lang="scss" scoped>
.order-info-block {
  dl {
    display: grid;
    grid-template-columns: 7em auto;
    margin-bottom: 1em;
  }
}
</style>
